import { API } from '@/config';
import { FILL_LIST, ASSIGN_MENU_ELEMENT, UNASSIGN_MENU_ELEMENT } from './mutations-types';

export default {
  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('project/mainMenu/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },
  async createMenu(context, params) {
    try {
      await API.put('project/mainMenu/createMenu', params);
    } catch (err) {
      console.log(err);
    }
  },
  async updateMenu(context, params) {
    try {
      await API.patch('project/mainMenu/updateMenu', params);
    } catch (err) {
      console.log(err);
    }
  },
  async setMessages(context, params) {
    try {
      await API.patch('project/mainMenu/setMessages', params);
    } catch (err) {
      console.log(err);
    }
  },
  async assignMenuElement({ commit }, params) {
    try {
      const result = await API.patch('project/mainMenu/keypad/assignMenuElement', { ...params });
      if (params.oldKeypadNumber) {
        commit(UNASSIGN_MENU_ELEMENT, { params });
      }
      commit(ASSIGN_MENU_ELEMENT, { params });
      return result;
    } catch (err) {
      console.log(err);
      return '';
    }
  },
  async unassignMenuElement({ commit }, params) {
    try {
      const result = await API.patch('project/mainMenu/keypad/unassignMenuElement', { ...params });
      commit(UNASSIGN_MENU_ELEMENT, { params });
      return result;
    } catch (err) {
      console.log(err);
      return '';
    }
  },
};
